import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  statusText: {
    whiteSpace: "nowrap",
    margin: `0px ${theme.spacing(1)}px`,
  },
}));
